module.exports = __webpack_public_path__ + "bfad400b6e7f5abb01b20a9531d522c7.svg";